import { NetworkBasePopUp } from '../NetworkBasePopUp';
import { translateFn } from '../../../../utils/translator.helper';
import { CreateTaskRequest } from '../../types';
import { getFormattedDateForTask } from '../../../networkAppContainer/helpers/utils';
import {SetVmwareIntegratorWebComponent} from "./component/SetVmwareIntegratorWebComponent";
import {FooterButton} from "../NetworkPopUpFooterContentWebComponent";
import {ButtonColors, ButtonTypes} from "../../../../ui/gzButton/types";
import {ProtectedEntity} from "@nirvana/shared/dtos/types/protected-entities/common";
import {RemoveRecordsResponse} from "../delete/types";
import {ConsoleRequest, DataProviderEntity, DataProviderType} from "../../../../utils/request";
import {GzToast, ToastSeverity} from "../../../../ui/gzToastNotification/type";
import {GzToastNotificationWebComponent} from "../../../../ui/gzToastNotification";
import {GzDialog} from "../../../../ui/gzDialog/component/GzDialog";
import {SetVMwareRecordsResponse} from "./types";
import { AFTER_UNMARK_EVENT_NAME } from '../goldenImage/unMark/UnmarkGoldenImagePopUp';

export const AFTER_ASSIGN_VMWARE_EVENT_NAME = 'afterAssignVmwareIntegrator';

export class SetVmwareIntegratorPopUp extends NetworkBasePopUp<SetVmwareIntegratorWebComponent> {
  protected transformToTaskTarget = true;
  protected customEventNameAfterConfirm = AFTER_ASSIGN_VMWARE_EVENT_NAME;
  protected title = translateFn('Create vCenter integration');
  private isError = false;
  protected extraDialogConfigs: Partial<GzDialog>;

  protected successDialogMessage = translateFn('Successfully assigned the integrator.');
  protected errorDialogMessage = translateFn('Failed to assign the integrator.');

  private dialogButtonsConfig: Partial<FooterButton>[] = [
    {
      id: 'confirmButton',
      label: translateFn('Save#preserve state'),
      type: ButtonTypes.FULL,
      color: ButtonColors.PRIMARY,
      disabled: true,
    },
    {
      id: 'closeButton',
      label: translateFn('CANCEL'),
      type: ButtonTypes.OUTLINE,
      color: ButtonColors.SECONDARY,
    },
  ];

  protected customSetup() {
    if (!this.data.targets) {
      throw new Error('Missing targets');
    }

    this.popUpContent = new SetVmwareIntegratorWebComponent(this.data.targets[0].company?.id ?? '');

    this.popUpFooterButtons = this.dialogButtonsConfig;
  }

  protected async handleConfirmButtonClicked(event: CustomEvent) {
    if (this.isError) {
      return;
    }

    const formValue = this.popUpContent.getFormValue();

    if (!this.data.targets) {
      throw new Error('Missing targets');
    }

    try {
      const response: SetVMwareRecordsResponse = await ConsoleRequest.createRequest<SetVMwareRecordsResponse>({
        dataProviderType: DataProviderType.ENDPOINTS,
        dataProviderEntity: DataProviderEntity.MODEL,
        endpoint: 'UnifiedEndpoints',
        method: 'setVCenterIntegrator',
        payload: {
          protectedEntityId: this.data.targets[0]._id,
          integrationProfileId: formValue,
        },
      });

      if (response?.success) {
        this.showCustomToast(this.successDialogMessage);
      } else {
        this.showErrorToastNotification(this.errorDialogMessage);
      }

    } catch (e) {
      console.error(e);
      this.showErrorToastNotification(e?.err?.message || this.errorDialogMessage);
    }

  }
}
